import dynamic from 'next/dynamic';
const Faq = dynamic(() => import('./Faq'));
export default Faq;
